import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const ModalCard = ({ image, title, subtitle, width }: any) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const isRtl = language === "ar";
  return (
    <Box
      sx={{
        direction: isRtl ? "rtl" : "ltr",
        width: { width },
        height: "190px",
        borderRadius: "24px",
        border: "1px solid #E2E8F0",
        padding: "24px",
        gap: "16px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        background:
          "linear-gradient(359.6deg, rgba(255, 255, 255, 0.04) 0.32%, rgba(91, 63, 255, 0.04) 103.81%)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          "& > *": {
            width: "44px !important",
            height: "44px !important",
            fontSize: "44px !important",
          },
        }}
      >
        {image}
      </Box>
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: "16px",
          lineHeight: "19.2px",
          letterSpacing: "0%",
          textAlign: isRtl ? "right" : "left",
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontWeight: 300,
          fontSize: "14px",
          lineHeight: "16.8px",
          letterSpacing: "0%",
          textAlign: isRtl ? "right" : "left",
          color: "#625783",
          paddingBottom: "16px",
        }}
      >
        {subtitle}
      </Typography>
    </Box>
  );
};

export default ModalCard;
